var _style, _polyline, _circle, _g, _polygon, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotlightLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 74.57",
    style: {
      enableBackground: "new 0 0 216 74.57"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#2B3451;}\n\t.st3{fill:url(#SVGID_00000011023769884674516360000001597895878083691907_);}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "122.97,20.9 124.49,22.66 124.84,22.66 126.32,20.9 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.2243,
    y1: 13.1569,
    x2: 130.1096,
    y2: 13.1569
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF4137"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 124.67,
    cy: 13.16,
    r: 5.44
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.57,64.38c0,0.94-0.69,1.42-1.44,1.51c-0.24,0.03-0.41,0.03-0.64,0.03h-1.65V60.5h1.51 c0.24,0,0.4,0,0.67,0.02c0.84,0.09,1.35,0.54,1.35,1.3c0,0.66-0.38,1.05-0.97,1.22C61.17,63.21,61.57,63.64,61.57,64.38z  M58.33,62.9h1.14c0.13,0,0.27-0.01,0.43-0.02c0.56-0.06,0.94-0.37,0.94-0.99c0-0.66-0.46-0.92-1-0.97 c-0.16-0.01-0.31-0.01-0.46-0.01h-1.05V62.9z M61.05,64.43c0-0.64-0.35-1.04-1.07-1.11c-0.18-0.02-0.3-0.02-0.42-0.02h-1.23v2.22 h1.27c0.13,0,0.27,0,0.37-0.01C60.55,65.46,61.05,65.12,61.05,64.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.1,65.92h-3.51V60.5h3.43v0.4h-2.95v2.11h2.74v0.41h-2.74v2.11h3.03V65.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.04,65.92V60.5h0.49v5.42H75.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.12,65.92l-2.82-4.95c0.02,0.67,0.02,1.48,0.02,2.15v2.8h-0.49V60.5h0.74l2.83,4.95 c-0.02-0.68-0.02-1.48-0.02-2.15v-2.8h0.48l0.01,5.42H84.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.44,63.38v2.54H94v-1.12l-0.21,0.49c-0.36,0.5-0.93,0.74-1.59,0.74c-1.49,0-2.42-1.15-2.42-2.8 c0-1.67,1.04-2.84,2.55-2.84c1.3,0,2,0.77,2.15,1.8l0.01,0.08H94l-0.02-0.08c-0.17-0.83-0.71-1.41-1.67-1.41 c-1.14,0-1.99,0.95-1.99,2.43c0,1.51,0.8,2.43,1.91,2.43c0.86,0,1.72-0.63,1.72-1.85h-1.48v-0.4H94.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.66,63.01h2.66v0.41h-2.66v2.51h-0.49V60.5h3.43v0.4h-2.95V63.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.83,63.93l-0.7,1.99h-0.52l2-5.42h0.65l1.96,5.42h-0.53l-0.71-1.99H113.83z M115.85,63.53l-0.92-2.63 l-0.96,2.63H115.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.25,65.92h-0.49V63c0-0.68,0-1.44,0.02-2.07c-0.21,0.63-0.49,1.39-0.74,2.06l-1.1,2.93h-0.61l-1.11-2.94 c-0.24-0.66-0.52-1.42-0.72-2.04c0.02,0.63,0.02,1.38,0.02,2.06v2.92h-0.49V60.5h0.79l1.83,5.01l1.82-5.01h0.78V65.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.2,63.21c0,1.63-0.94,2.82-2.52,2.82c-1.58,0-2.51-1.19-2.51-2.82c0-1.65,0.93-2.82,2.51-2.82 C136.26,60.39,137.2,61.56,137.2,63.21z M136.65,63.21c0-1.52-0.81-2.43-1.98-2.43c-1.16,0-1.97,0.9-1.97,2.43 c0,1.52,0.81,2.43,1.97,2.43C135.84,65.64,136.65,64.73,136.65,63.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.01,63.98c0,0.16-0.01,0.31-0.02,0.5c-0.06,0.88-0.67,1.55-1.9,1.55c-1.24,0-1.84-0.67-1.91-1.55 c-0.02-0.19-0.02-0.35-0.02-0.5V60.5h0.49v3.46c0,0.17,0,0.33,0.02,0.48c0.06,0.68,0.51,1.2,1.42,1.2c0.9,0,1.35-0.52,1.41-1.2 c0.02-0.15,0.02-0.31,0.02-0.48V60.5h0.49V63.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.61,61.95h-0.51c-0.09-0.74-0.57-1.17-1.28-1.17c-0.62,0-1.19,0.32-1.19,0.97c0,0.66,0.38,0.9,1.31,1.14 c1.16,0.3,1.74,0.74,1.74,1.63c0,0.9-0.79,1.51-1.82,1.51c-1.1,0-1.89-0.56-2.01-1.6h0.52c0.13,0.78,0.73,1.21,1.51,1.21 c0.72,0,1.29-0.41,1.29-1.04c0-0.7-0.41-1-1.42-1.25c-1.03-0.27-1.64-0.63-1.64-1.5c0-0.88,0.8-1.46,1.76-1.46 C153.94,60.39,154.51,61.07,154.61,61.95z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103974986445512522320000014813238069404817831_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.6075,
    y1: 32.7985,
    x2: 131.7264,
    y2: 32.7985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF4137"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103974986445512522320000014813238069404817831_)"
    },
    d: "M117.61,20.77h14.12 c0,0-3.99,8.4-3.65,24.06h-6.77h6.72h-6.77C121.59,29.17,117.61,20.77,117.61,20.77h14.12"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124.67,39.5 126.32,37.86 124.67,20.9 122.97,37.84 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.64,24.08h-2.67c-0.49-3.86-2.96-6.12-6.7-6.12c-3.25,0-6.25,1.68-6.25,5.05c0,3.45,2.01,4.73,6.86,5.96 c6.08,1.56,9.12,3.86,9.12,8.55s-4.11,7.89-9.53,7.89c-5.75,0-9.9-2.92-10.52-8.38h2.71c0.7,4.07,3.82,6.33,7.89,6.33 c3.74,0,6.74-2.14,6.74-5.42c0-3.66-2.14-5.22-7.44-6.53c-5.38-1.4-8.59-3.29-8.59-7.85c0-4.6,4.19-7.64,9.21-7.64 C40.14,15.9,43.1,19.47,43.64,24.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.54,33.69c0,7.89-4.85,11.71-10.35,11.71c-2.14,0-4.23-0.66-5.59-1.93l-1.36-2.34v11.75h-2.55V22.97h2.55 v4.15l1.44-2.38c1.52-1.48,3.66-2.22,6.16-2.22C64.93,22.52,68.54,27.24,68.54,33.69z M65.75,34.02c0-5.22-2.51-9.45-7.27-9.45 c-3.86,0-7.23,2.3-7.23,8.88v1.64c0,6.2,3.74,8.3,6.95,8.3C62.54,43.39,65.75,39.9,65.75,34.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.13,33.98c0,6.37-3.66,11.42-10.56,11.42s-10.56-5.05-10.56-11.42c0-6.41,3.66-11.46,10.56-11.46 S92.13,27.57,92.13,33.98z M89.34,33.98c0-5.92-3.25-9.41-7.77-9.41c-4.52,0-7.77,3.49-7.77,9.41s3.25,9.41,7.77,9.41 C86.09,43.39,89.34,39.9,89.34,33.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.66,38.87c0,0.9,0,1.36,0.04,1.93c0.17,2.1,1.07,2.63,3.99,2.26v1.89c-0.86,0.17-1.77,0.21-2.63,0.21 c-2.42,0-3.7-1.07-3.9-3.45c-0.04-0.74-0.04-1.56-0.04-2.79V25.23h-2.79v-1.97h2.79v-4.81h2.55v4.81h4.15v1.97h-4.15V38.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.42,39.08c0,0.95,0,1.68,0.04,2.34c0.08,1.4,0.7,1.77,2.55,1.56v1.89c-0.66,0.12-1.36,0.12-2.01,0.12 c-1.69,0-2.96-0.58-3.08-2.92c-0.04-0.74-0.04-1.6-0.04-2.92V14.63h2.55V39.08z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.84,39.32c0,2.14,0,3.82-0.04,5.09c-0.21,5.79-3.82,9.21-9.78,9.21c-5.38,0-8.67-2.22-9.21-6.94 l-0.04-0.49h2.55l0.08,0.49c0.37,3.21,2.96,4.93,6.62,4.93c4.6,0,7.07-2.75,7.23-7.07c0.04-1.19,0.04-2.05,0.04-3.21V40.8 l-1.44,2.38c-1.52,1.52-3.66,2.22-6.16,2.22c-6.08,0-9.7-4.73-9.7-11.18c0-7.89,4.85-11.71,10.36-11.71c2.14,0,4.23,0.66,5.59,1.97 l1.36,2.34v-3.78h2.55V39.32z M153.29,34.47v-1.64c0-6.16-3.74-8.26-6.94-8.26c-4.36,0-7.56,3.45-7.56,9.33 c0,5.22,2.51,9.49,7.27,9.49C149.92,43.39,153.29,41.05,153.29,34.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.47,32.67v12.16h-2.55V32.95c0-1.23,0-2.18-0.08-3.29c-0.29-2.96-1.93-5.1-5.59-5.05 c-3.62,0.04-6.78,2.63-6.78,9.41v10.81h-2.55V14.42h2.55v12.86l1.15-2.34c1.77-1.77,3.7-2.42,6.12-2.42c4.6,0,7.23,2.51,7.64,6.49 C179.47,30.12,179.47,30.9,179.47,32.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.59,38.87c0,0.9,0,1.36,0.04,1.93c0.16,2.1,1.07,2.63,3.99,2.26v1.89c-0.86,0.17-1.77,0.21-2.63,0.21 c-2.42,0-3.7-1.07-3.9-3.45c-0.04-0.74-0.04-1.56-0.04-2.79V25.23h-2.79v-1.97h2.79v-4.81h2.55v4.81h4.15v1.97h-4.15V38.87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlightLogo);
export default __webpack_public_path__ + "static/media/SpotlightLogo.05e495ca1f93a26933e66c9558bf0550.svg";
export { ForwardRef as ReactComponent };